import React, { useState } from "react";
import PropTypes from "prop-types";
import { graphql, useStaticQuery } from "gatsby";
import { Alert } from "react-bootstrap";
import classNames from "classnames";

import RichTextBlock from "./RichTextBlock";

import "../styles/components/HeaderBanner.scss";

const HeaderBanner = ({ banner }) => {
    let { text, linkText, linkTarget } = banner || {};
    const [show, setShow] = useState(true);
    const defaultBanner = useStaticQuery(graphql`
        query DefaultBannerQuery {
            contentfulBanner(defaultBanner: { eq: true }) {
                linkTarget
                linkText
                text {
                    raw
                }
            }
        }
    `)?.contentfulBanner;

    // // Uncomment the following conditional if the banner should be completely removed
    // // from the page when it is closed. Please note that doing that will shift content in
    // // the header to take up the space freed by the banner removal.
    // if (!show) {
    //     return null;
    // }

    if (!text) {
        if (defaultBanner) {
            ({ text, linkText, linkTarget } = defaultBanner);
        } else {
            return null;
        }
    }

    return (
        <Alert
            className={classNames("header-banner", {
                invisible: !show,
                "d-md-none": !show,
            })}
            variant="primary"
            dismissible
            onClose={() => setShow(false)}
        >
            <div className="d-flex flex-column flex-md-row">
                <RichTextBlock content={text} />
                {linkTarget && (
                    <Alert.Link
                        href={linkTarget}
                        target="_blank"
                        className="ms-md-auto"
                    >
                        {linkText} &rarr;
                    </Alert.Link>
                )}
            </div>
        </Alert>
    );
};

HeaderBanner.propTypes = {
    banner: PropTypes.shape({
        text: PropTypes.shape({ raw: PropTypes.string }),
        linkText: PropTypes.string,
        linkTarget: PropTypes.string,
    }),
};

export default HeaderBanner;
